import { useState } from "react";
import { faqItems } from "@/mocks/brand";

export default function HomeFAQ() {
  const [openId, setOpenId] = useState<string | null>("faq-1");

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            关于JM网页版的常见疑问
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            这里整理了一些用户最常问到的问题，希望能帮助您更好地使用JM网页版
          </p>
        </div>
        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() =>
                  setOpenId(openId === item.id ? null : item.id)
                }
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer group"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <div
                  className={`w-7 h-7 flex items-center justify-center rounded-full bg-background-100 flex-shrink-0 transition-transform duration-300 ${
                    openId === item.id ? "rotate-45" : ""
                  }`}
                >
                  <i className="ri-add-line text-foreground-600"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openId === item.id ? "max-h-96 pb-5" : "max-h-0"
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}